import config from "@Config/index";
import { isRegionalBlogLanguage, type RegionalBlogLanguage } from "./blogLanguage";
import getCmsRequestUrl from "./getCmsRequestUrl";

export type { RegionalBlogLanguage };

const CHINA_PREFIXED_COLLECTIONS = ["blog-posts", "categories", "blogs-home-featured-limited"];

const LANGUAGE_PREFIXED_COLLECTIONS = [
  "blog-posts",
  "categories",
  "tags",
  "countries",
  "blogs-home-featured-limited",
];

const SHARED_COLLECTIONS = ["blog-partners"];

const getBlogCollectionUrl = (requested: string, lang?: RegionalBlogLanguage): string => {
  const collection =
    config.IS_CHINA_APP && requested === "blog-articles" ? "blog-posts" : requested;

  // Shared collections never get prefixed
  if (SHARED_COLLECTIONS.includes(collection)) {
    return getCmsRequestUrl(`/api/${collection}`);
  }

  // China app always uses china- prefix
  if (config.IS_CHINA_APP && CHINA_PREFIXED_COLLECTIONS.includes(collection)) {
    return getCmsRequestUrl(`/api/china-${collection}`);
  }

  if (isRegionalBlogLanguage(lang) && LANGUAGE_PREFIXED_COLLECTIONS.includes(collection)) {
    return getCmsRequestUrl(`/api/${lang}-${collection}`);
  }

  // Default: English (no prefix)
  return getCmsRequestUrl(`/api/${collection}`);
};

export default getBlogCollectionUrl;
